import styled from 'styled-components'

const FullAndSeparateSettingsIconsContainerUi = styled.div`
  display: flex;
`

export default FullAndSeparateSettingsIconsContainerUi
